import React, { FunctionComponent } from 'react';
import { InfoIconPopup } from '../common/InfoIconPopup';

export interface ChartInstructionsProps {
  isEditPage?: boolean;
}

const sectionLabelStyle: React.CSSProperties = { marginBottom: 2 };
const instructionLineStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
};

export const ChartInstructions: FunctionComponent<ChartInstructionsProps> = ({ isEditPage = false }) => (
  <InfoIconPopup size={16} openTo="right" width={isEditPage ? 320 : 300} title="About this chart" opacity={0.65}>
    <div style={instructionLineStyle}>
      {isEditPage ? (
        <>
          <div style={sectionLabelStyle}>
            <strong>When on the draft:</strong>
          </div>
          <div>• Create a new root seat using the plus button on the right.</div>
          <div>• Scroll the mouse wheel to zoom in and out.</div>
          <div>• Right-click and drag to move around the chart.</div>
          <div>• Click and hold a node to drag it.</div>
          <div>• Click and drag to select multiple nodes.</div>
          <div style={{ ...sectionLabelStyle, marginTop: 4 }}>
            <strong>When on a version:</strong>
          </div>
          <div>• Scroll the mouse wheel to zoom in and out.</div>
          <div>• Click and drag to move around the chart.</div>
        </>
      ) : (
        <>
          <div>• Scroll the mouse wheel to zoom in and out.</div>
          <div>• Click and drag to move around the chart.</div>
        </>
      )}
    </div>
  </InfoIconPopup>
);
